import qs from "qs";
import { useCallback, useEffect, useState } from "react";

const initState: Record<string, unknown> = {};

export default () => {
  const [query, setQuery] = useState(initState);
  const getQuery = useCallback(() => {
    const urlParams = new URL(window.location.href);
    const { search } = urlParams;
    setQuery(qs.parse(search.substring(1)));
  }, []);

  useEffect(() => {
    const handlePopState = () => {
      getQuery();
    };
    getQuery();

    window.addEventListener("popstate", handlePopState);

    return () => {
      window.removeEventListener("popstate", handlePopState);
    };
  }, [getQuery]);

  return {
    query,
    getQuery,
  };
};
